<!-- <gp-income-summary (click)="$event.stopPropagation();"></gp-income-summary>  -->

<div class="flex-row-container m-b5 m-t10" > 
  <span class="B flex-1 font20"></span>
  <button mat-stroked-button class="m-r10" [ngClass]="isDataChanged?'highlight-bg':''"  color="primary" (click)="saveSelectedIncomes()">Save</button>
  <button [matMenuTriggerFor]="incomemenu" class="m-r10 font14" mat-stroked-button  color="primary">Add Income</button>
</div>
<mat-table *ngIf="dataSource" [dataSource]="dataSource"> 
    <ng-container matColumnDef="select" sticky>
      <mat-header-cell *matHeaderCellDef style="width: 20px !important;">
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell   *matCellDef="let row" >
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selectionToggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
            
        <ng-container matColumnDef="incDesc" sticky>
          <mat-header-cell *matHeaderCellDef class="p-r10"> INCOME </mat-header-cell>
          <mat-cell class="text-truncate p-r10" *matCellDef="let element">
             
              <div class="flex-col-container">
                <span>{{element.incDesc}}</span>
                <span class="blueText14">{{element.incType}} </span>                
              </div>            
          </mat-cell>                      
        </ng-container>

        <ng-container matColumnDef="owner">
          <mat-header-cell *matHeaderCellDef class="p-l10"> OWNER </mat-header-cell>
          <mat-cell *matCellDef="let element" class="p-l10"> {{element.owner}} </mat-cell>
        </ng-container>
      
        <ng-container matColumnDef="amount">
          <mat-header-cell class="th-right" *matHeaderCellDef> INCOME ($) </mat-header-cell>
          <mat-cell class="p-tb5 th-right" *matCellDef="let element"> 
            <div class="flex-col-end">
              {{element.amount | currency:'USD': 'symbol' : '1.0-0'}}
              <span class="gray-text font14" *ngIf="element.isMonthly">per month</span>
              <span class="gray-text font14" *ngIf="!element.isMonthly">per year</span>            
            </div>
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="growthType">
          <mat-header-cell class="th-right p-r10" *matHeaderCellDef> ANNUAL INFLATION </mat-header-cell>
          <mat-cell class="p-r10 p-tb5 th-right" *matCellDef="let element"> 
            <div class="flex-col-end">
                <span>{{element.growthType==='INF'?'Inflation': (element.growthRate | number : '1.2-2')}} <span>{{element.growthType==='INF'?'': '%'}}</span></span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startYr">
            <mat-header-cell class="th-right" *matHeaderCellDef> START YEAR </mat-header-cell>
            <mat-cell class="p-tb5 th-right" *matCellDef="let element"> 
              <div class="flex-col-end">
                {{element.startType==='AtRet'?'At Retirement': element.startYr}}
                <span class="gray-text font14" *ngIf="element.startType==='Age'"><span class="B m-r3">Age:</span> {{element.startAge}} </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="endYr">
            <mat-header-cell class="th-right" *matHeaderCellDef> END YEAR </mat-header-cell>
            <mat-cell class="p-tb5 th-right" *matCellDef="let element"> 
              <!-- {{element.endType==='Duration'?'No. of Years:':''}}
              {{element.endType==='AtEnd'?'Rest of Life':
                (element.endType==='AtRet'?'At Retirement':
                (element.endType==='Duration'?element.duration:
                element.endYr))}} -->
              {{element.endType==='Duration'?'No. of Years:':''}}
              {{element.endType==='Age'?'Age:':''}}
              {{element.endType==='AtEnd'?'Rest of Life':
                (element.endType==='AtRet'?'At Retirement':
                (element.endType==='Duration'?element.duration:
                (element.endType==='Age'?element.endAge:
                element.endYr)))}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell class="th-right" *matHeaderCellDef >
            </mat-header-cell>
            <mat-cell class="th-right" *matCellDef="let element" >
                <mat-icon class="font18 m-l10 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit Income" (click)="editIncome(element.incId)">edit</mat-icon>
                <mat-icon class="font18 m-l12 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Delete Income"  (click)="deleteIncome(element.incId, element.incDesc)">delete</mat-icon>
            </mat-cell>
        </ng-container>
        
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
</mat-table>
  
<mat-menu #incomemenu="matMenu">
  <ng-container *ngFor="let item of incomeTypeMenuItems">
    <button *ngIf="item.type!=='Joint'" class="font14" mat-menu-item [matMenuTriggerFor]="sub_menu"> {{item.displayClientname}}</button>
    <button *ngIf="item.type==='Joint'" class="font14" mat-menu-item (click)="addIncome('OT', '0')"> {{item.displayClientname}}</button>
    <mat-menu #sub_menu="matMenu">
         <button *ngFor="let subItem of item.subMenuItems" class="font14" mat-menu-item (click)="addIncome(subItem.code, subItem.clientid)" >{{ subItem.value }}</button>
    </mat-menu>
  </ng-container> 
</mat-menu>


<!-- <mat-menu #incomemenu="matMenu">
    <button class="font14" *ngFor="let item of incomeTypeMenuItems" mat-menu-item>
      <span>{{item.desc}}</span>
    </button>  
  </mat-menu> -->


<!-- <mat-menu #incomemenu="matMenu" xPosition="before">
<button class="font14" [matMenuTriggerFor]="clients" mat-menu-item>Income for {{primaryClient.clientname}}</button>
<button class="font14" [matMenuTriggerFor]="clients" mat-menu-item *ngIf="secondaryClient">Income for  {{secondaryClient.clientname}}</button>


</mat-menu>

<mat-menu #clients="matMenu" xPosition="before">
<button class="font14"   *ngFor="let itemTypeRef of incomeTypesRef" mat-menu-item (click)="addIncome()">
  <span>{{itemTypeRef.value}}</span>
</button> 
</mat-menu> -->

